/**
 * Replace new lines with <br>
 * @param {string} string
 * @returns {string}
 */
export const NL2BR = string => string.replace(/\n/g, '<br>');
